module.exports = __webpack_public_path__ + "static/media/simpleHoldIcon.b2354b98.svg";